import gql from 'graphql-tag';

export default gql`
  query {
    announces {
      _id
      title
      content
      startDate
      endDate
      image
      createdAt
      updatedAt
    }
  }
`;
